import { useTheme } from "@mui/material/styles";

import { ThemeModes } from "../../muiThemeTypes";

export const useDarkThemeCheck = () => {
  const theme = useTheme();

  return theme.palette.mode === ThemeModes.DARK;
};
